interface EarningsIndicatorProps {
  earnings: number;
}

const EarningsIndicator: React.FC<EarningsIndicatorProps> = ({ earnings }) => {
  return (
    <div
      className={`text-xs p-1 rounded justify-center items-center flex w-fit bg-primary-80 text-primary-30`}
    >
      {(earnings || 0).toFixed(2)}
    </div>
  );
};

export default EarningsIndicator;
